<template>
  <el-progress :percentage="props.progress">
    <span class="text">{{ props.text }} {{ props.progress }}%</span>
  </el-progress>
</template>

<script setup>
defineOptions({
  name: 'UploadProgress'
})

const props = defineProps({
  progress: {
    type: Number,
    default: 0
  },
  text: {
    type: String,
    default: '上传中'
  }
})
</script>

<style scoped lang="scss">
.text {
  font-size: 14px;
  white-space: nowrap;
}
</style>
